import i18next from 'i18next';
import { Condition } from '../../../@types/Condition';
import { RadioItem } from '../../../Components/Input/InputRadioGroup';
import { translateCondition } from '../../../Utils/constants';

const Usps = (type: Condition): string[] => {
  switch (type) {
    case Condition.VeryGood:
      return i18next.t('mileageAndCondition.condition.veryGood.requirements', {
        returnObjects: true,
      });

    case Condition.Good:
      return i18next.t('mileageAndCondition.condition.good.requirements', {
        returnObjects: true,
      });

    case Condition.Ok:
      return i18next.t('mileageAndCondition.condition.ok.requirements', {
        returnObjects: true,
      });

    default:
      return [''];
  }
};

const createDescription = (usp: string[]) => `
  <div class="waykevaluation-box">
    <div class="waykevaluation-content waykevaluation-content--inherit-size">
      <ul class="waykevaluation-content__ul">
        ${usp.map((u) => ` <li class="waykevaluation-content__li">${u}</li>`).join('')}
      </ul>
    </div>
  </div>
`;

const RadioElements = (): RadioItem[] => {
  return [
    {
      id: `radio-${Condition.VeryGood}`,
      value: Condition.VeryGood,
      title: translateCondition(Condition.VeryGood),
      description: createDescription(Usps(Condition.VeryGood)),
    },
    {
      id: `radio-${Condition.Good}`,
      value: Condition.Good,
      title: translateCondition(Condition.Good),
      description: createDescription(Usps(Condition.Good)),
    },
    {
      id: `radio-${Condition.Ok}`,
      value: Condition.Ok,
      title: translateCondition(Condition.Ok),
      description: createDescription(Usps(Condition.Ok)),
    },
  ];
};

export default RadioElements;
